export const SHARE_ADD_BUTTONS_DEV = 'TZofPveMRmikuacajJXnYQ';
export const SHARE_ADD_BUTTONS = '831nW6IvQKSybiIbfxN-Cg';